import { useCheckboxState } from '../abstract/checkbox';

export function usePoolFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: pool, setChecked: onPoolChange } = useCheckboxState({
    defaultValue: query.pool,
    filterKey: `pool`,
    setFilters,
    updateQuery,
  });

  return { pool, onPoolChange };
}
